import { ORG_SIZE_VALUES } from "@/utils/risk-calculator";
import type { WizardSectorStep } from "@/types/risk-wizard";
import type {
  AttackCategoryData,
  OrganizationSize,
  RiskMatrixData,
} from "@/types/risk-analysis";

type SectorProgressStatus = "completed" | "current" | "upcoming" | "skipped";

export type SectorProgressItem = {
  sectorId: string;
  sectorCode: string;
  sectorName: string;
  status: SectorProgressStatus;
};

export function buildSectorProgressItems(
  sectorSteps: WizardSectorStep[],
  currentSectorIndex: number
): SectorProgressItem[] {
  return sectorSteps.map((step, idx) => ({
    sectorId: step.sectorId,
    sectorCode: step.sectorCode,
    sectorName: step.sectorName,
    status: (step.status === "completed"
      ? "completed"
      : idx === currentSectorIndex
        ? "current"
        : step.status === "skipped"
          ? "skipped"
          : "upcoming") as SectorProgressStatus,
  }));
}

export function buildSaveMatrixPayload(
  sessionId: string,
  sectorId: string,
  orgSize: OrganizationSize,
  attackMatrix: AttackCategoryData[]
): { session_id: string; sector_id: string; matrix: RiskMatrixData } {
  return {
    session_id: sessionId,
    sector_id: sectorId,
    matrix: {
      industry: sectorId,
      entity_size_score: ORG_SIZE_VALUES[orgSize],
      risk_assessment: attackMatrix.map((category) => ({
        attack_category: category.categoryId,
        nature_of_attack: category.tipAtac === "global" ? 1 : 2,
        impact: category.impact,
        threat_actors: category.actors,
      })),
    },
  };
}

export function buildBulkInsertRecords(
  sessionId: string,
  sectorIds: string[]
): { session_id: string; sector_id: string }[] {
  return sectorIds.map((sectorId) => ({
    session_id: sessionId,
    sector_id: sectorId,
  }));
}
